import { Component, OnInit, ViewChild } from '@angular/core';
import { AbstractWidgetComponent } from '@sdbn/appclient';
import { ContextChange } from '@sdbn/appclient';
import { TranslationService } from '@sdbn/common';
import { ZXingScannerComponent } from '@zxing/ngx-scanner';
import { TerminalContextConstants } from 'src/tmc-common/model/terminal-context-constants';
import { environment } from 'src/environments/environment';
import { TerminalVisitorRegistration } from '../../visitor-registration.model';
import { ResponseStatus } from '@sdbn/appclient';
import { LogContainer } from 'src/tmc-common/model/log-container.model';
import { ValidationMessage, ValidationMessageType } from '@sdbn/appclient';
import { HttpService } from '@sdbn/appclient';
import { Result } from '@zxing/library';

@Component({
  selector: 'app-visitor-scan-registration-qrcode',
  templateUrl: './visitor-scan-registration-qrcode.component.html',
  styleUrls: ['./visitor-scan-registration-qrcode.component.scss']
})
export class VisitorScanRegistrationQRCodeComponent extends AbstractWidgetComponent implements OnInit {

  // 'scanned-visitor-registration-qrcode'
  private readonly CONTEXT_KEY_SCANNED_BARCODE = 'barcodeScanned';

  scannerEnabled = false;

  deviceCurrent: MediaDeviceInfo;
  deviceSelected: string;

  errorMessageDictionaryKey: string;

  @ViewChild('scanner', { static: true })
  scanner: ZXingScannerComponent;

  constructor(
    private httpService: HttpService,
    public translationService: TranslationService
  ) {
    super();
  }

  ngOnInit(): void {
    this.scanner.tryHarder = true;
  }

  onContextChange(contextChange: ContextChange) {
  }

  onSetElementAndContext() {

  }

  public camerasFoundHandler(devices: MediaDeviceInfo[]) {

    console.log('camerasFoundHandler', devices);
    if (devices != null && devices.length > 0) {
        this.deviceCurrent = devices[0];
        this.scannerEnabled = true;
    }
    
  }

  public camerasNotFound($event: any) {
    console.log('camerasNotFound', $event);
    this.errorMessageDictionaryKey = 'tmc-yard.widgets.registration-terminal.visitor-scan-registration-qrcode.error.no-camera-found';
  }



  public scanSuccessHandler($event: string) {
    console.log("scansuccess:", $event);

    if($event.startsWith('tmc-visit://registration?')) {
      this.processQRCodeContent($event);

    } else if($event.startsWith('tmc-visit://visitor')) {
      this.validateScannedBarcodeAndGetVisitData($event);

    } else {
      this.errorMessageDictionaryKey = 'tmc-yard.widgets.registration-terminal.visitor-scan-registration-qrcode.error.invalid-qrcode';
    }
  }

  scanCompleteHandler($event: Result) {
    console.log("scanCompleteHandler:", $event);
    //this.scanner.scanStop();
    //this.scannerEnabled = false;
  }

  scanErrorHandler($event: Error) {
    console.error('Failed to scan', $event);
  }

  private processQRCodeContent(qrCodeContent: string) {
    const url = new URL(qrCodeContent);
    const registrationDate = Number(url.searchParams.get('registrationDate'));

    if (registrationDate + 24 * 60 * 60 * 1000 < Date.now()) {
      this.errorMessageDictionaryKey = 'tmc-yard.widgets.registration-terminal.visitor-scan-registration-qrcode.error.invalid-qrcode';
    } else {
      const lastname = url.searchParams.get('lastname');
      const firstname = url.searchParams.get('firstname');
      const company = url.searchParams.get('company');
      const numberPlate = url.searchParams.get('numberPlate');
      const visitedPerson = url.searchParams.get('visitedPerson');
      const needsAreaAccess = url.searchParams.get('needsAreaAccess');
      const visitorType = url.searchParams.get('visitorType');
      const registrationCode = url.searchParams.get('registrationCode');
      const inviterId = url.searchParams.get('inviterId');

      // wenn ein registration code enthalten ist, dann mit dem die Visitor-Daten laden
      if (registrationCode != null && registrationCode.trim().length > 0) {
         this.validateRegistrationCodeAndGetVisitData(qrCodeContent, registrationCode);
      } else {
        this.dashboardContext.setContextValue(TerminalContextConstants.lastname, lastname != null ? lastname : null);
        this.dashboardContext.setContextValue(TerminalContextConstants.firstname,  firstname != null ? firstname : null);
        this.dashboardContext.setContextValue(TerminalContextConstants.company, company != null ? company : null);
        this.dashboardContext.setContextValue(TerminalContextConstants.numberPlate, numberPlate != null ? numberPlate : null);
        this.dashboardContext.setContextValue(TerminalContextConstants.visitedPerson, visitedPerson != null ? visitedPerson : null);
        this.dashboardContext.setContextValue('needsAreaAccess', needsAreaAccess != null && needsAreaAccess === 'true');
        this.dashboardContext.setContextValue('visitorType', visitorType);
        this.dashboardContext.setContextValue('inviterId', inviterId);

        this.errorMessageDictionaryKey = null;
        this.scannerEnabled = false;
        this.dashboardContext.setContextValue(this.CONTEXT_KEY_SCANNED_BARCODE, qrCodeContent);
      }
    }
  }

  private validateRegistrationCodeAndGetVisitData(qrCodeContent: string, registrationCode: string) {

    this.dashboardContext.setContextValue(TerminalContextConstants.isLoading, true);
    this.httpService.postWithContext(environment.registrationVisitorCodeEndpoint, {code: registrationCode})
      .toPromise().then((response: TerminalVisitorRegistration) => {
        const success = this.handleTerminalVisitorRegistrationResponse(response);
        if (success) {
          this.errorMessageDictionaryKey = null;
          this.scannerEnabled = false;
          this.dashboardContext.setContextValue(this.CONTEXT_KEY_SCANNED_BARCODE, qrCodeContent);
        }
      });
  }

  private validateScannedBarcodeAndGetVisitData(qrCodeContent: string) {

    this.dashboardContext.setContextValue(TerminalContextConstants.isLoading, true);
    this.httpService.postWithContext(environment.registrationVisitorWithBarcodeEndpoint, {value: qrCodeContent})
      .toPromise().then((response: TerminalVisitorRegistration) => {
        const success = this.handleTerminalVisitorRegistrationResponse(response);
        if (success) {
          this.errorMessageDictionaryKey = null;
          this.scannerEnabled = false;
          this.dashboardContext.setContextValue(this.CONTEXT_KEY_SCANNED_BARCODE, qrCodeContent);
        }
    }, error => {
        // TODO specify what happens for bad codes
    });
  }

  private handleTerminalVisitorRegistrationResponse(response: TerminalVisitorRegistration): boolean {
      console.log("validateRegistrationCodeAndGetVisitData", response);
      this.dashboardContext.setContextValue(TerminalContextConstants.isLoading, false);
      this.dashboardContext.setContextValue(TerminalContextConstants.responseMessages, response.responseMessages);
      if (response.status !== ResponseStatus.FAILED) {

          const registration = new TerminalVisitorRegistration(response);

          this.dashboardContext.setContextValue(TerminalContextConstants.numberPlate, registration.numberPlate);
          this.dashboardContext.setContextValue(TerminalContextConstants.lastname, registration.name);
          this.dashboardContext.setContextValue(TerminalContextConstants.firstname, registration.firstname);
          this.dashboardContext.setContextValue(TerminalContextConstants.company, registration.company);
          this.dashboardContext.setContextValue(TerminalContextConstants.gcCaseId, registration.gcCaseId);
          this.dashboardContext.setContextValue(TerminalContextConstants.registrationId, registration.registrationId);
          this.dashboardContext.setContextValue(TerminalContextConstants.reasonForVisit, registration.reason);
          this.dashboardContext.setContextValue(TerminalContextConstants.visitedPerson, registration.visitedPerson);
          this.dashboardContext.setContextValue('needsAreaAccess', registration.needsAreaAccess);

          const logContainer: LogContainer = this.dashboardContext.context.get(TerminalContextConstants.logContainer);
          logContainer.addLog('Valid code detected. New visitor.');


          return true;
      } else {
        const validationMessages = new Array<ValidationMessage>();
        for (const responseMessage of response.responseMessages) {
          validationMessages.push(ValidationMessage.createWithData(ValidationMessageType.ERROR, responseMessage.dictionaryKey));
        }
        this.dashboardContext.setContextValue('validationMessages', validationMessages);
        this.dashboardContext.setContextValue('responseMessages', validationMessages);
        return false;
      }
  }
}
